import { z } from 'zod';

export const paymentMethodTypeSchema = z.enum(['stripe', 'braintree', 'razorpay', 'affirm', 'external', 'void']);

export const savedCreditCardSchema = z
  .object({
    last4: z.string(),
    name: z.string().nullable(),
    brand: z.string(),
    exp_month: z.string(),
    exp_year: z.string(),
    card_country: z.string().nullable(),
    address_country: z.string(),
  })
  .transform((data) => ({
    last4: data.last4,
    name: data.name,
    brand: data.brand,
    expMonth: data.exp_month,
    expYear: data.exp_year,
    cardCountry: data.card_country,
    addressCountry: data.address_country,
  }));

export const userPaymentMethodSchema = z
  .object({
    urn: z.string(),
    id: z.string(),
    type: paymentMethodTypeSchema,
    user_id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    saved_credit_card: savedCreditCardSchema.nullable(),
  })
  .transform((data) => ({
    id: data.id,
    urn: data.urn,
    type: data.type,
    userId: data.user_id,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    savedCreditCard: data.saved_credit_card,
  }));

export const userPaymentMethodsResponseSchema = z
  .object({
    version: z.string(),
    payment_methods: z.array(userPaymentMethodSchema),
  })
  .transform((data) => data.payment_methods);

export type PaymentMethodType = z.infer<typeof paymentMethodTypeSchema>;
export type SavedCreditCard = z.infer<typeof savedCreditCardSchema>;
export type UserPaymentMethod = z.infer<typeof userPaymentMethodSchema>;
export type UserPaymentMethods = z.infer<typeof userPaymentMethodsResponseSchema>;
export type UserPaymentMethodsResponse = z.input<typeof userPaymentMethodsResponseSchema>;
